"use strict";

exports.__esModule = true;
var _InfoCards = _interopRequireDefault(require("./InfoCards"));
exports.default = _InfoCards.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}